<template>
    <div class="main-tests-pass">
        <div class="testPass">
            <div class="testPass_nav">
                <h1>{{ currentTestInfo.title }}</h1>
                <button type="button" class="testPass-btn" @click.prevent="$router.push('/lkstudents/tests')">Список тестов</button>
            </div>
            <div class="testPass_body">
                <div class="testPass_body_f">
                    <div class="testPass_body-name">
                        <div class="name-container">
                            <inline-svg :src="getIcon(currentTestInfo)" />
                            <p>{{ currentTestInfo.bodySystemName }}</p>
                        </div>
                    </div>
                    <div class="testPass_body-info">
                        <div class="info-container">
                            <div class="text-container">
                                <p>Дисциплина</p>
                                <p>{{ currentTestInfo.studyDisciplineName }}</p>
                            </div>
                            <div class="text-container">
                                <p>Тема</p>
                                <p>{{ currentTestInfo.studyTopicName }}</p>
                            </div>
                            <div class="text-container">
                                <p>Вопрос</p>
                                <p>{{ currentStep }} / {{ $route.query.questionsCount }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="testPass_body-timer">
                        <div class="time">
                            <timer-component :time="prettyTime"  />

                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 32 32" fill="none">
                                <path d="M15.9998 30.3334C8.09317 30.3334 1.6665 23.9067 1.6665 16.0001C1.6665 8.09341 8.09317 1.66675 15.9998 1.66675C23.9065 1.66675 30.3332 8.09341 30.3332 16.0001C30.3332 23.9067 23.9065 30.3334 15.9998 30.3334ZM15.9998 3.66675C9.19984 3.66675 3.6665 9.20008 3.6665 16.0001C3.6665 22.8001 9.19984 28.3334 15.9998 28.3334C22.7998 28.3334 28.3332 22.8001 28.3332 16.0001C28.3332 9.20008 22.7998 3.66675 15.9998 3.66675Z" fill="#4854FE"/>
                                <path d="M20.9467 21.2401C20.7734 21.2401 20.6 21.2001 20.44 21.0934L16.3067 18.6268C15.28 18.0134 14.52 16.6668 14.52 15.4801V10.0134C14.52 9.46676 14.9734 9.01343 15.52 9.01343C16.0667 9.01343 16.52 9.46676 16.52 10.0134V15.4801C16.52 15.9601 16.92 16.6668 17.3334 16.9068L21.4667 19.3734C21.9467 19.6534 22.0934 20.2668 21.8134 20.7468C21.6134 21.0668 21.28 21.2401 20.9467 21.2401Z" fill="#4854FE"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="testPass_body-quest">
                    <div class="testPass_body-container">
                        <!-- <div class="quest-number-container">
                            <div class="quest-number" v-for="(item, idx) in currentTestInfo.questions" :key="'U'+idx" >
                                <div
                                    class="number"
                                    :class="{
                                        'active': idx === isActive,
                                        'currectNum': item.correct === true,
                                        'wrongNum': item.correct === false
                                    }"
                                    ref="questNumber"
                                >
                                    @click.prevent="isActive = idx"
                                    {{ idx + 1 }}
                                </div>
                                <div class="space" v-if="currentTestInfo.questions.length > 1 && idx + 1 !== currentTestInfo.questions.length">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="2" viewBox="0 0 42 2" fill="none">
                                        <path d="M0 1H41.5" stroke="#CACDD3" stroke-dasharray="2 2"/>
                                    </svg>
                                </div>
                            </div>
                        </div> -->

                        <div class="quest-txt-container mt-4">
                            <div class="text-container">
                                <p v-if="isActive >= 0">{{ currentTestInfo.questions[isActive].title }}</p>
                                <media-files v-if="currentTestInfo.questions[isActive].files.length > 0" :files="currentTestInfo.questions[isActive].files" />

                                <p v-if="currentTestInfo.questions[isActive].questionType === 0" class="txt">Выберите один вариант ответа</p>
                                <p v-if="currentTestInfo.questions[isActive].questionType === 1" class="txt">Выберите несколько вариантов ответа</p>
                                <p v-if="currentTestInfo.questions[isActive].questionType === 2" class="txt">Установите соответствие</p>

                                <div v-if="currentTestInfo.questions[isActive].questionType === 0">
                                    <ul class="text-options" v-if="isActive >= 0">
                                        <li
                                            v-for="(it, i) in currentTestInfo.questions[isActive].answers"
                                            :key="'L'+i"
                                            class="options-item"
                                            @click.prevent="checkQuest ? '' : pushCheck(it)"
                                        >
                                            <div class="addTask_checkbox-wrap" :ref="'check'+it.id">
                                                <label
                                                    for="check"
                                                    class="newCheck"
                                                    :class="{ 'box': currentTestInfo.questions[isActive].selectedQ0.id == it.id }"
                                                />
                                                <input type="checkbox" name="check" id="check" style="display: none;">
                                                {{ it.title }}
                                                <svg v-if="answers[isActive] && answers[isActive].ind == i" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.2 8.62192L12.1636 20.6641C11.6787 21.112 10.8926 21.112 10.4077 20.6641L4.19995 14.9297L5.95578 13.3078L11.2857 18.2312L23.4441 7L25.2 8.62192Z"/>
                                                </svg>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div v-if="currentTestInfo.questions[isActive].questionType === 1">
                                    <ul class="text-options" v-if="isActive >= 0">
                                        <li
                                            v-for="(it, i) in currentTestInfo.questions[isActive].answers"
                                            :key="'L'+i"
                                            class="options-item"
                                            @click.prevent="checkQuest ? '' : pushCheckLot(it)"
                                        >
                                            <div class="addTask_checkbox-wrap" :ref="'checkLot'+it.id">
                                                <label
                                                    for="check"
                                                    class="newCheck"
                                                    :class="{ 'box': currentTestInfo.questions[isActive].selectedQ1.indexOf(it.id) !== -1 }"
                                                />
                                                <input type="checkbox" name="check" id="check" style="display: none;">
                                                {{ it.title }}
                                                <svg v-if="answers[isActive] && answers[isActive].ind == i" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.2 8.62192L12.1636 20.6641C11.6787 21.112 10.8926 21.112 10.4077 20.6641L4.19995 14.9297L5.95578 13.3078L11.2857 18.2312L23.4441 7L25.2 8.62192Z"/>
                                                </svg>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div v-if="currentTestInfo.questions[isActive].questionType === 2">
                                    <div
                                        v-for="(it, key) in currentTestInfo.questions[isActive].terms"
                                        :key="'B'+key"
                                        class="py-2 my-4"
                                        :class="{
                                            'successAnswer': it.correct,
                                            'errorAnswer': it.correct === false,
                                            'border-top-left-radius-7': key === 0,
                                            'border-bottom-left-radius-7': key === (currentTestInfo.questions[isActive].terms.length - 1),
                                        }"
                                    >
                                        <v-row>
                                            <v-col cols="12" sm="5" md="4">
                                                {{ it.title }}
                                            </v-col>
                                            <v-col cols="12" sm="7" md="8">
                                                <v-select
                                                    outlined
                                                    dense
                                                    hide-details
                                                    :clearable="it.selected && !checkQuest ? true : false"
                                                    :disabled="checkQuest"
                                                    item-text="title"
                                                    item-value="id"
                                                    return-object
                                                    v-model="it.selected"
                                                    @focus="selectTerms(currentTestInfo.questions[isActive], it)"
                                                    @change="changeSelected($event, currentTestInfo.questions[isActive])"
                                                    :items="it.list"
                                                    label=""
                                                >
                                                    <template v-slot:selection="{ item }">
                                                        <span
                                                            :class="{
                                                                'green--text text--lighten-1': it.correct,
                                                                'red--text text--lighten-1': !it.correct && checkQuest
                                                            }"
                                                        >
                                                            {{item.title}}
                                                        </span>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </div>
                            </div>

                            <v-expand-transition>
                                <div v-if="checkQuest" class="info-text">
                                    <p :class="{ 'green--text text--lighten-1': success, 'red--text text--lighten-1': !success }">{{ text }}</p>
                                </div>
                            </v-expand-transition>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-container">
                <button
                    refs="btnPass"
                    :class="{'btnActive':!currentTestInfo.questions[isActive].isDiasabled}"
                    :disabled='currentTestInfo.questions[isActive].isDiasabled || loadCheck'
                    @click.prevent="currentTestInfo.questions[isActive].questionType === 2 ? checkQuestType2(currentTestInfo.questions[isActive]) : checkQusest(currentTestInfo.questions[isActive])"
                >
                    Показать правильный ответ
                </button>
                <button refs="next" class="next" :class="{'hide': currentTestInfo.questions[isActive].isDiasabledNext || currentTestInfo.questions.length-1 == isActive}" @click.prevent="pushNext">
                    Дальше
                </button>

                
                <button
                    style="position: relative;"
                    refs="next"
                    class="next"
                    :class="{'hide': !checkQuest}"
                    :disabled="loadingGetResult"
                    v-if="currentTestInfo.questions.length-1 == isActive"
                    @click.prevent="getMark(currentTestInfo)"
                >
                    <v-overlay :value="loadingGetResult" absolute>
                        <v-progress-circular indeterminate size="24" />
                    </v-overlay>
                    Получить оценку
                </button>
            </div>

            <div v-show="clickShow" class="tessPass-mark">
                <div class="mark-container">
                    <button class="close" @click.prevent="$router.push('/lkstudents/tests')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                            <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </button>
                    <div class="mark-body">
                        <p>Ваша оценка</p>
                        <div class="mark-icon-container">
                            <div class="icon-wrap">
                                <v-progress-circular
                                    :value="percentages.int"
                                    :size="195"
                                    :color="percentages.color"
                                    :width="15"
                                >
                                    <div class="icon" :style="'color:'+ percentages.color">
                                        <svg v-if="percentages.int >= 0 && percentages.int <= 39" width="57" height="57" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.15723 28.1821L10.9603 22.9218C11.174 22.5207 11.5904 22.2705 12.0451 22.2705C12.4998 22.2705 12.9159 22.5207 13.1295 22.9218L15.9629 28.239C16.1288 28.5575 16.2975 28.8726 16.4409 29.1972C16.5807 29.5143 16.687 29.84 16.7413 30.1832C16.7785 30.419 16.7924 30.6565 16.7924 30.8948C16.7918 33.517 14.6676 35.6424 12.0451 35.6424C9.42259 35.6424 7.2997 33.5167 7.29748 30.8951C7.29693 30.4035 7.37407 29.9216 7.54302 29.4591C7.70004 29.0286 7.91671 28.6277 8.13393 28.2254L8.15723 28.1821ZM33.0762 15.6977C31.4993 15.6977 30.2204 16.9749 30.2204 18.5541C30.2204 20.1301 31.4998 21.411 33.0762 21.411C34.6528 21.411 35.9323 20.1301 35.9323 18.5541C35.9323 16.9761 34.6545 15.6977 33.0762 15.6977ZM13.9219 15.6977C12.345 15.6977 11.0661 16.9749 11.0661 18.5541C11.0661 20.1301 12.3455 21.411 13.9219 21.411C15.4985 21.411 16.778 20.1301 16.778 18.5541C16.778 16.9761 15.5001 15.6977 13.9219 15.6977ZM23.5003 0.5C36.2028 0.5 46.5 10.7972 46.5 23.4997C46.5 36.2028 36.2028 46.5 23.5003 46.5C10.7972 46.5 0.5 36.2028 0.5 23.4997C0.5 10.7972 10.7972 0.5 23.5003 0.5ZM23.5 3.98142C34.2799 3.98142 43.0186 12.72 43.0186 23.5C43.0186 34.2799 34.2799 43.0186 23.5 43.0186C12.7201 43.0186 3.98143 34.2799 3.98143 23.5C3.98143 12.72 12.7201 3.98142 23.5 3.98142ZM18.4442 28.525C17.6349 29.0421 16.548 28.8033 16.0309 27.9935C15.514 27.1839 15.7537 26.0978 16.5627 25.5804C18.6481 24.2474 21.0589 23.548 23.5336 23.548C26.3109 23.548 28.9991 24.4291 31.2321 26.0809C32.0075 26.6546 32.1715 27.7493 31.5981 28.5247C31.0244 29.3004 29.9302 29.4647 29.1545 28.8915C27.5196 27.6833 25.5663 27.0427 23.5336 27.0427C21.7231 27.0427 19.9703 27.5504 18.4442 28.525ZM13.9491 29.6877L13.8736 29.5459C13.8544 29.5102 13.8356 29.4752 13.8176 29.4408L12.0451 26.1133L10.2931 29.4008C10.1392 29.6777 9.96133 29.994 9.85535 30.293C9.77934 30.5069 9.75604 30.6659 9.75576 30.8953C9.75493 31.5079 9.9938 32.0816 10.426 32.5138C10.8585 32.9463 11.4325 33.1838 12.0451 33.1838C12.6574 33.1838 13.2311 32.9461 13.6636 32.5138C14.0961 32.0813 14.3341 31.5076 14.3341 30.8948C14.3341 30.7874 14.3305 30.6773 14.3133 30.571C14.3003 30.49 14.2797 30.4165 14.2523 30.3391C14.179 30.1321 14.0634 29.9038 13.9491 29.6877Z" fill="#EE4040"/>
                                        </svg>

                                        <svg v-if="percentages.int >= 40 && percentages.int <= 69" width="57" height="57" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7874 32.882C14.411 33.7506 13.3906 34.1537 12.522 33.7772C11.6531 33.4005 11.2503 32.3804 11.627 31.5115C12.616 29.2299 14.2481 27.278 16.3135 25.8961C18.4445 24.4704 20.9366 23.7161 23.5005 23.7161C26.0637 23.7161 28.555 24.4713 30.6856 25.8961C32.7507 27.2774 34.3831 29.228 35.3727 31.5087C35.7497 32.3776 35.3466 33.3977 34.4777 33.7745C33.6091 34.1509 32.5893 33.7484 32.2125 32.8798C31.4865 31.2061 30.2858 29.7715 28.7702 28.7578C27.2042 27.7102 25.3845 27.1609 23.5005 27.1609C21.616 27.1609 19.7961 27.7102 18.2297 28.7583C16.7142 29.7726 15.5132 31.208 14.7874 32.882ZM23.5003 0.5C36.2028 0.5 46.5 10.7972 46.5 23.4997C46.5 36.2028 36.2028 46.5 23.5003 46.5C10.7972 46.5 0.5 36.2028 0.5 23.4997C0.5 10.7972 10.7972 0.5 23.5003 0.5ZM23.5 3.98142C34.2799 3.98142 43.0185 12.7201 43.0185 23.5C43.0185 34.2799 34.2799 43.0186 23.5 43.0186C12.72 43.0186 3.9814 34.2799 3.9814 23.5C3.9814 12.7201 12.72 3.98142 23.5 3.98142ZM13.9219 15.6977C12.345 15.6977 11.066 16.9749 11.066 18.5541C11.066 20.1301 12.3455 21.411 13.9219 21.411C15.4985 21.411 16.778 20.1301 16.778 18.5541C16.778 16.9761 15.5001 15.6977 13.9219 15.6977ZM33.0762 15.6977C31.4993 15.6977 30.2204 16.9749 30.2204 18.5541C30.2204 20.1301 31.4998 21.411 33.0762 21.411C34.6528 21.411 35.9323 20.1301 35.9323 18.5541C35.9323 16.9761 34.6544 15.6977 33.0762 15.6977Z" fill="#EEC840"/>
                                        </svg>

                                        <svg v-if="percentages.int >= 70 && percentages.int <= 90" width="57" height="57" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M33.2743 26.5445C33.5578 25.6326 34.5291 25.121 35.441 25.4062C36.3515 25.6908 36.8614 26.6596 36.5779 27.571C35.7198 30.3277 34.0039 32.7438 31.6943 34.4716C29.3237 36.2449 26.4604 37.1932 23.5003 37.1932C20.5401 37.1932 17.6768 36.2449 15.3062 34.4716C12.9967 32.7438 11.2808 30.3277 10.423 27.571C10.1394 26.6596 10.6491 25.6908 11.5596 25.4062C12.4715 25.121 13.4428 25.6326 13.7263 26.5445C14.3669 28.6038 15.6525 30.411 17.378 31.7013C19.1536 33.0288 21.2834 33.734 23.5003 33.734C25.7172 33.734 27.8473 33.029 29.6228 31.7013C31.3481 30.411 32.634 28.6035 33.2743 26.5445ZM23.5003 0.5C36.2028 0.5 46.5 10.7972 46.5 23.4997C46.5 36.2028 36.2028 46.5 23.5003 46.5C10.7972 46.5 0.5 36.2028 0.5 23.4997C0.5 10.7972 10.7972 0.5 23.5003 0.5ZM23.5 3.9814C34.2799 3.9814 43.0186 12.7201 43.0186 23.5C43.0186 34.2799 34.2799 43.0186 23.5 43.0186C12.7201 43.0186 3.98143 34.2799 3.98143 23.5C3.98143 12.7201 12.7201 3.9814 23.5 3.9814ZM13.9219 15.6977C12.345 15.6977 11.0661 16.9749 11.0661 18.554C11.0661 20.1301 12.3455 21.411 13.9219 21.411C15.4985 21.411 16.778 20.1301 16.778 18.554C16.778 16.976 15.5001 15.6977 13.9219 15.6977ZM33.0762 15.6977C31.4993 15.6977 30.2204 16.9749 30.2204 18.554C30.2204 20.1301 31.4998 21.411 33.0762 21.411C34.6528 21.411 35.9323 20.1301 35.9323 18.554C35.9323 16.976 34.6545 15.6977 33.0762 15.6977Z" fill="#21B8DA"/>
                                        </svg>

                                        <svg v-if="percentages.int >= 91" width="57" height="57" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5003 0.5C36.2028 0.5 46.5 10.7972 46.5 23.4997C46.5 36.2028 36.2028 46.5 23.5003 46.5C10.7972 46.5 0.5 36.2028 0.5 23.4997C0.5 10.7972 10.7972 0.5 23.5003 0.5ZM23.5 3.98141C34.2799 3.98141 43.0186 12.7201 43.0186 23.5C43.0186 34.2799 34.2799 43.0186 23.5 43.0186C12.7201 43.0186 3.98143 34.2799 3.98143 23.5C3.98143 12.7201 12.7201 3.98141 23.5 3.98141ZM13.9219 15.6977C12.345 15.6977 11.066 16.9749 11.066 18.5541C11.066 20.1301 12.3455 21.411 13.9219 21.411C15.4985 21.411 16.778 20.1301 16.778 18.5541C16.778 16.9761 15.5001 15.6977 13.9219 15.6977ZM34.9261 25.3088C35.4798 25.3088 36.0022 25.5751 36.3315 26.0199C36.6625 26.4665 36.7596 27.0455 36.5945 27.5765C35.7362 30.3372 34.0178 32.7566 31.7054 34.4866C29.3318 36.2624 26.464 37.2118 23.5 37.2118C20.5357 37.2118 17.6688 36.2624 15.2949 34.4866C12.9822 32.7566 11.2633 30.3374 10.4052 27.5765C10.2404 27.0466 10.3378 26.4701 10.666 26.0232C10.9953 25.5746 11.5177 25.3088 12.0742 25.3088H34.9261ZM32.3835 28.8102L14.6953 28.8765C15.3009 30.0448 16.1263 30.7444 17.388 31.6877C19.1605 33.0132 21.2867 33.7171 23.5 33.7171C25.7127 33.7171 27.8395 33.0132 29.612 31.6877C30.9009 30.7239 31.7623 30.0131 32.3835 28.8102ZM33.0762 15.6977C31.4993 15.6977 30.2204 16.9749 30.2204 18.5541C30.2204 20.1301 31.4998 21.411 33.0762 21.411C34.6528 21.411 35.9323 20.1301 35.9323 18.5541C35.9323 16.9761 34.6545 15.6977 33.0762 15.6977Z" fill="#33A56E"/>
                                        </svg>
                                        {{ percentages.int }}%
                                    </div>
                                </v-progress-circular>
                            </div>
                            <p>{{ percentages.txt }}</p>
                        </div>
                        <button class="mark-btn" :disabled="loadingSaveResult" @click="saveResult(currentTestInfo)">Сохранить результат</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="tests-pass-mobile">
            <div class="testPass_nav">
                <h1>{{ currentTestInfo.title }}</h1>
                <button type="button" class="testPass-btn" @click.prevent="$router.push('/lkstudents/tests')">Список тестов</button>
                <div class="d-flex justify-center name-container">
                    <!-- <inline-svg style="width: 20px;" :src="getIcon(currentTestInfo)" />
                    <a style="color:#4854FE; margin-left:5px; margin-top: 5px;" @click="showInfo = !showInfo">{{ currentTestInfo.bodySystemName }}</a> -->
                    <timer-component class="mt-4 timer-mobile" :time="prettyTime"  />
                </div>
            </div>
            <div class="testPass_body">
                <div class="testPass_body-info">
                    <div class="info-container">
                        <div class="text-container">
                            <p>Дисциплина</p>
                            <p>{{ currentTestInfo.studyDisciplineName }}</p>
                        </div>
                        <div class="text-container">
                            <p>Тема</p>
                            <p>{{ currentTestInfo.studyTopicName }}</p>
                        </div>
                        <div class="text-container">
                            <p>Вопрос</p>
                            <p>{{ currentStep }} / {{ $route.query.questionsCount }}</p>
                        </div>
                    </div>
                </div>


                <div class="testPass_body-quest">
                    <div class="testPass_body-container">
                        <!-- <div class="quest-number-container">
                            <div class="quest-number" v-for="(item, idx) in currentTestInfo.questions" :key="'U'+idx" >
                                <div
                                    class="number"
                                    :class="{
                                        'active': idx === isActive,
                                        'currectNum': item.correct === true,
                                        'wrongNum': item.correct === false
                                    }"
                                    ref="questNumber"
                                    @click.prevent="isActive = idx"
                                >
                                    {{ idx + 1 }}
                                </div>
                                <div class="space" v-if="questions.length > 1 && idx + 1 !== questions.length">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="2" viewBox="0 0 42 2" fill="none">
                                        <path d="M0 1H41.5" stroke="#CACDD3" stroke-dasharray="2 2"/>
                                    </svg>
                                </div>
                            </div>
                        </div> -->

                        <div class="quest-txt-container">
                            <div class="text-container">
                                <p v-if="isActive >= 0">{{ currentTestInfo.questions[isActive].title }}</p>
                                <media-files v-if="currentTestInfo.questions[isActive].files.length > 0" :files="currentTestInfo.questions[isActive].files" />

                                <p v-if="currentTestInfo.questions[isActive].questionType === 0" class="txt">Выберите один вариант ответа</p>
                                <p v-if="currentTestInfo.questions[isActive].questionType === 1" class="txt">Выберите несколько вариантов ответа</p>
                                <p v-if="currentTestInfo.questions[isActive].questionType === 2" class="txt">Установите соответствие</p>

                                <div v-if="currentTestInfo.questions[isActive].questionType === 0">
                                    <ul class="text-options" v-if="isActive >= 0">
                                        <li
                                            v-for="(it, i) in currentTestInfo.questions[isActive].answers"
                                            :key="'L'+i"
                                            class="options-item"
                                            @click.prevent="checkQuest ? '' : pushCheck(it)"
                                        >
                                            <div class="addTask_checkbox-wrap" :ref="'check'+it.id">
                                                <div class="label">
                                                    <label
                                                        for="check"
                                                        class="newCheck"
                                                        :class="{ 'box': currentTestInfo.questions[isActive].selectedQ0.id == it.id }"
                                                    />
                                                    <input type="checkbox" name="check" id="check" style="display: none;">
                                                </div>
                                                <div class="text">
                                                    {{ it.title }}
                                                </div>
                                                <svg v-if="answers[isActive] && answers[isActive].ind == i" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.2 8.62192L12.1636 20.6641C11.6787 21.112 10.8926 21.112 10.4077 20.6641L4.19995 14.9297L5.95578 13.3078L11.2857 18.2312L23.4441 7L25.2 8.62192Z"/>
                                                </svg>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div v-if="currentTestInfo.questions[isActive].questionType === 1">
                                    <ul class="text-options" v-if="isActive >= 0">
                                        <li
                                            v-for="(it, i) in currentTestInfo.questions[isActive].answers"
                                            :key="'L'+i"
                                            class="options-item"
                                            @click.prevent="checkQuest ? '' : pushCheckLot(it)"
                                        >
                                            <div class="addTask_checkbox-wrap" :ref="'checkLot'+it.id">
                                                <div class="label">
                                                    <label
                                                        for="check"
                                                        class="newCheck"
                                                        :class="{ 'box': currentTestInfo.questions[isActive].selectedQ1.indexOf(it.id) !== -1 }"
                                                    />
                                                    <input type="checkbox" name="check" id="check" style="display: none;">
                                                </div>
                                                <div class="text">
                                                    {{ it.title }}
                                                </div>
                                                <svg v-if="answers[isActive] && answers[isActive].ind == i" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.2 8.62192L12.1636 20.6641C11.6787 21.112 10.8926 21.112 10.4077 20.6641L4.19995 14.9297L5.95578 13.3078L11.2857 18.2312L23.4441 7L25.2 8.62192Z"/>
                                                </svg>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div v-if="currentTestInfo.questions[isActive].questionType === 2">
                                    <div
                                        v-for="(it, key) in currentTestInfo.questions[isActive].terms"
                                        :key="'B'+key"
                                        class="py-2 my-4"
                                        :class="{
                                            'successAnswer': it.correct,
                                            'errorAnswer': it.correct === false,
                                            'border-top-left-radius-7': key === 0,
                                            'border-bottom-left-radius-7': key === (currentTestInfo.questions[isActive].terms.length - 1),
                                        }"
                                    >
                                        <v-row>
                                            <v-col cols="12" sm="5" md="4">
                                                {{ it.title }}
                                            </v-col>
                                            <v-col cols="12" sm="7" md="8">
                                                <v-select
                                                    outlined
                                                    dense
                                                    hide-details
                                                    :clearable="it.selected && !checkQuest ? true : false"
                                                    :disabled="checkQuest"
                                                    item-text="title"
                                                    item-value="id"
                                                    return-object
                                                    v-model="it.selected"
                                                    @focus="selectTerms(currentTestInfo.questions[isActive], it)"
                                                    @change="changeSelected($event, currentTestInfo.questions[isActive])"
                                                    :items="it.list"
                                                    label=""
                                                >

                                                    <template v-slot:item="{ item, on, attrs }">
                                                        <v-list-item v-bind="attrs" v-on="on">
                                                            <v-list-item-content>
                                                                <v-list-item-title style="white-space: normal;">
                                                                    {{ item.title }}
                                                                </v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>

                                                    <template v-slot:selection="{ item }">
                                                        <span
                                                            :class="{
                                                                'green--text text--lighten-1': it.correct,
                                                                'red--text text--lighten-1': !it.correct && checkQuest
                                                            }"
                                                        >
                                                            {{item.title}}
                                                        </span>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </div>
                            </div>

                            <v-expand-transition>
                                <div v-if="checkQuest" class="info-text">
                                    <p :class="{ 'green--text text--lighten-1': success, 'red--text text--lighten-1': !success }">{{ text }}</p>
                                </div>
                            </v-expand-transition>
                        </div>
                    </div>
                </div>
            </div>
        <div class="btn-container">
                <button
                    style="width: 100%; margin-top: 10px;"
                    refs="btnPass"
                    :class="{'btnActive':!currentTestInfo.questions[isActive].isDiasabled}"
                    :disabled='currentTestInfo.questions[isActive].isDiasabled || loadCheck'
                    @click.prevent="currentTestInfo.questions[isActive].questionType === 2 ? checkQuestType2(currentTestInfo.questions[isActive]) : checkQusest(currentTestInfo.questions[isActive])"
                >
                    Показать правильный ответ
                </button>
                <button style="margin-top: 10px;" refs="next" class="next" :class="{'hide': currentTestInfo.questions[isActive].isDiasabledNext || currentTestInfo.questions.length-1 == isActive}" @click.prevent="pushNext">
                    Дальше
                </button>
                <button
                    style="margin-top: 10px; position: relative;"
                    refs="next"
                    class="next"
                    :class="{'hide': !checkQuest}"
                    v-if="currentTestInfo.questions.length-1 == isActive"
                    @click.prevent="getMark(currentTestInfo)"
                >
                    <v-overlay :value="loadingGetResult" absolute>
                        <v-progress-circular indeterminate size="24" />
                    </v-overlay>
                    Получить оценку
                </button>
            </div>
        <div v-show="clickShow" class="tessPass-mark">
            <div class="mark-container">
                <button class="close" @click.prevent="$router.push('/lkstudents/tests')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                        <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
                <div class="mark-body">
                    <p>Ваша оценка</p>
                    <div class="mark-icon-container">
                        <div class="icon-wrap">
                            <v-progress-circular
                                :value="percentages.int"
                                :size="195"
                                :color="percentages.color"
                                :width="15"
                            >
                                <div class="icon" :style="'color:'+ percentages.color">
                                    <svg v-if="percentages.int >= 0 && percentages.int <= 39" width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.15723 28.1821L10.9603 22.9218C11.174 22.5207 11.5904 22.2705 12.0451 22.2705C12.4998 22.2705 12.9159 22.5207 13.1295 22.9218L15.9629 28.239C16.1288 28.5575 16.2975 28.8726 16.4409 29.1972C16.5807 29.5143 16.687 29.84 16.7413 30.1832C16.7785 30.419 16.7924 30.6565 16.7924 30.8948C16.7918 33.517 14.6676 35.6424 12.0451 35.6424C9.42259 35.6424 7.2997 33.5167 7.29748 30.8951C7.29693 30.4035 7.37407 29.9216 7.54302 29.4591C7.70004 29.0286 7.91671 28.6277 8.13393 28.2254L8.15723 28.1821ZM33.0762 15.6977C31.4993 15.6977 30.2204 16.9749 30.2204 18.5541C30.2204 20.1301 31.4998 21.411 33.0762 21.411C34.6528 21.411 35.9323 20.1301 35.9323 18.5541C35.9323 16.9761 34.6545 15.6977 33.0762 15.6977ZM13.9219 15.6977C12.345 15.6977 11.0661 16.9749 11.0661 18.5541C11.0661 20.1301 12.3455 21.411 13.9219 21.411C15.4985 21.411 16.778 20.1301 16.778 18.5541C16.778 16.9761 15.5001 15.6977 13.9219 15.6977ZM23.5003 0.5C36.2028 0.5 46.5 10.7972 46.5 23.4997C46.5 36.2028 36.2028 46.5 23.5003 46.5C10.7972 46.5 0.5 36.2028 0.5 23.4997C0.5 10.7972 10.7972 0.5 23.5003 0.5ZM23.5 3.98142C34.2799 3.98142 43.0186 12.72 43.0186 23.5C43.0186 34.2799 34.2799 43.0186 23.5 43.0186C12.7201 43.0186 3.98143 34.2799 3.98143 23.5C3.98143 12.72 12.7201 3.98142 23.5 3.98142ZM18.4442 28.525C17.6349 29.0421 16.548 28.8033 16.0309 27.9935C15.514 27.1839 15.7537 26.0978 16.5627 25.5804C18.6481 24.2474 21.0589 23.548 23.5336 23.548C26.3109 23.548 28.9991 24.4291 31.2321 26.0809C32.0075 26.6546 32.1715 27.7493 31.5981 28.5247C31.0244 29.3004 29.9302 29.4647 29.1545 28.8915C27.5196 27.6833 25.5663 27.0427 23.5336 27.0427C21.7231 27.0427 19.9703 27.5504 18.4442 28.525ZM13.9491 29.6877L13.8736 29.5459C13.8544 29.5102 13.8356 29.4752 13.8176 29.4408L12.0451 26.1133L10.2931 29.4008C10.1392 29.6777 9.96133 29.994 9.85535 30.293C9.77934 30.5069 9.75604 30.6659 9.75576 30.8953C9.75493 31.5079 9.9938 32.0816 10.426 32.5138C10.8585 32.9463 11.4325 33.1838 12.0451 33.1838C12.6574 33.1838 13.2311 32.9461 13.6636 32.5138C14.0961 32.0813 14.3341 31.5076 14.3341 30.8948C14.3341 30.7874 14.3305 30.6773 14.3133 30.571C14.3003 30.49 14.2797 30.4165 14.2523 30.3391C14.179 30.1321 14.0634 29.9038 13.9491 29.6877Z" fill="#EE4040"/>
                                    </svg>

                                    <svg v-if="percentages.int >= 40 && percentages.int <= 69" width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7874 32.882C14.411 33.7506 13.3906 34.1537 12.522 33.7772C11.6531 33.4005 11.2503 32.3804 11.627 31.5115C12.616 29.2299 14.2481 27.278 16.3135 25.8961C18.4445 24.4704 20.9366 23.7161 23.5005 23.7161C26.0637 23.7161 28.555 24.4713 30.6856 25.8961C32.7507 27.2774 34.3831 29.228 35.3727 31.5087C35.7497 32.3776 35.3466 33.3977 34.4777 33.7745C33.6091 34.1509 32.5893 33.7484 32.2125 32.8798C31.4865 31.2061 30.2858 29.7715 28.7702 28.7578C27.2042 27.7102 25.3845 27.1609 23.5005 27.1609C21.616 27.1609 19.7961 27.7102 18.2297 28.7583C16.7142 29.7726 15.5132 31.208 14.7874 32.882ZM23.5003 0.5C36.2028 0.5 46.5 10.7972 46.5 23.4997C46.5 36.2028 36.2028 46.5 23.5003 46.5C10.7972 46.5 0.5 36.2028 0.5 23.4997C0.5 10.7972 10.7972 0.5 23.5003 0.5ZM23.5 3.98142C34.2799 3.98142 43.0185 12.7201 43.0185 23.5C43.0185 34.2799 34.2799 43.0186 23.5 43.0186C12.72 43.0186 3.9814 34.2799 3.9814 23.5C3.9814 12.7201 12.72 3.98142 23.5 3.98142ZM13.9219 15.6977C12.345 15.6977 11.066 16.9749 11.066 18.5541C11.066 20.1301 12.3455 21.411 13.9219 21.411C15.4985 21.411 16.778 20.1301 16.778 18.5541C16.778 16.9761 15.5001 15.6977 13.9219 15.6977ZM33.0762 15.6977C31.4993 15.6977 30.2204 16.9749 30.2204 18.5541C30.2204 20.1301 31.4998 21.411 33.0762 21.411C34.6528 21.411 35.9323 20.1301 35.9323 18.5541C35.9323 16.9761 34.6544 15.6977 33.0762 15.6977Z" fill="#EEC840"/>
                                    </svg>

                                    <svg v-if="percentages.int >= 70 && percentages.int <= 90" width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M33.2743 26.5445C33.5578 25.6326 34.5291 25.121 35.441 25.4062C36.3515 25.6908 36.8614 26.6596 36.5779 27.571C35.7198 30.3277 34.0039 32.7438 31.6943 34.4716C29.3237 36.2449 26.4604 37.1932 23.5003 37.1932C20.5401 37.1932 17.6768 36.2449 15.3062 34.4716C12.9967 32.7438 11.2808 30.3277 10.423 27.571C10.1394 26.6596 10.6491 25.6908 11.5596 25.4062C12.4715 25.121 13.4428 25.6326 13.7263 26.5445C14.3669 28.6038 15.6525 30.411 17.378 31.7013C19.1536 33.0288 21.2834 33.734 23.5003 33.734C25.7172 33.734 27.8473 33.029 29.6228 31.7013C31.3481 30.411 32.634 28.6035 33.2743 26.5445ZM23.5003 0.5C36.2028 0.5 46.5 10.7972 46.5 23.4997C46.5 36.2028 36.2028 46.5 23.5003 46.5C10.7972 46.5 0.5 36.2028 0.5 23.4997C0.5 10.7972 10.7972 0.5 23.5003 0.5ZM23.5 3.9814C34.2799 3.9814 43.0186 12.7201 43.0186 23.5C43.0186 34.2799 34.2799 43.0186 23.5 43.0186C12.7201 43.0186 3.98143 34.2799 3.98143 23.5C3.98143 12.7201 12.7201 3.9814 23.5 3.9814ZM13.9219 15.6977C12.345 15.6977 11.0661 16.9749 11.0661 18.554C11.0661 20.1301 12.3455 21.411 13.9219 21.411C15.4985 21.411 16.778 20.1301 16.778 18.554C16.778 16.976 15.5001 15.6977 13.9219 15.6977ZM33.0762 15.6977C31.4993 15.6977 30.2204 16.9749 30.2204 18.554C30.2204 20.1301 31.4998 21.411 33.0762 21.411C34.6528 21.411 35.9323 20.1301 35.9323 18.554C35.9323 16.976 34.6545 15.6977 33.0762 15.6977Z" fill="#21B8DA"/>
                                    </svg>

                                    <svg v-if="percentages.int >= 91" width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5003 0.5C36.2028 0.5 46.5 10.7972 46.5 23.4997C46.5 36.2028 36.2028 46.5 23.5003 46.5C10.7972 46.5 0.5 36.2028 0.5 23.4997C0.5 10.7972 10.7972 0.5 23.5003 0.5ZM23.5 3.98141C34.2799 3.98141 43.0186 12.7201 43.0186 23.5C43.0186 34.2799 34.2799 43.0186 23.5 43.0186C12.7201 43.0186 3.98143 34.2799 3.98143 23.5C3.98143 12.7201 12.7201 3.98141 23.5 3.98141ZM13.9219 15.6977C12.345 15.6977 11.066 16.9749 11.066 18.5541C11.066 20.1301 12.3455 21.411 13.9219 21.411C15.4985 21.411 16.778 20.1301 16.778 18.5541C16.778 16.9761 15.5001 15.6977 13.9219 15.6977ZM34.9261 25.3088C35.4798 25.3088 36.0022 25.5751 36.3315 26.0199C36.6625 26.4665 36.7596 27.0455 36.5945 27.5765C35.7362 30.3372 34.0178 32.7566 31.7054 34.4866C29.3318 36.2624 26.464 37.2118 23.5 37.2118C20.5357 37.2118 17.6688 36.2624 15.2949 34.4866C12.9822 32.7566 11.2633 30.3374 10.4052 27.5765C10.2404 27.0466 10.3378 26.4701 10.666 26.0232C10.9953 25.5746 11.5177 25.3088 12.0742 25.3088H34.9261ZM32.3835 28.8102L14.6953 28.8765C15.3009 30.0448 16.1263 30.7444 17.388 31.6877C19.1605 33.0132 21.2867 33.7171 23.5 33.7171C25.7127 33.7171 27.8395 33.0132 29.612 31.6877C30.9009 30.7239 31.7623 30.0131 32.3835 28.8102ZM33.0762 15.6977C31.4993 15.6977 30.2204 16.9749 30.2204 18.5541C30.2204 20.1301 31.4998 21.411 33.0762 21.411C34.6528 21.411 35.9323 20.1301 35.9323 18.5541C35.9323 16.9761 34.6545 15.6977 33.0762 15.6977Z" fill="#33A56E"/>
                                    </svg>
                                    {{ percentages.int }}%
                                </div>
                            </v-progress-circular>
                        </div>
                        <p>{{ percentages.txt }}</p>
                    </div>
                    <button class="mark-btn" :disabled="loadingSaveResult" @click="saveResult(currentTestInfo)">Сохранить результат</button>
                </div>
            </div>
        </div>
        </div>

        <v-snackbar v-model="snackbar.flag" top rounded="pill" elevation="24" :color="snackbar.color">
            <v-icon>mdi-information</v-icon>
            {{ snackbar.text }}
        </v-snackbar>
    </div>

</template>

<script>
import mediaFiles from '@/components/TaskMediaFiles.vue'
import InlineSvg from 'vue-inline-svg';
import { mapGetters, mapActions } from 'vuex'
import apexchart from 'vue-apexcharts'
import timerComponent from '@/components/Timer/index.vue';
import './index.scss'

export default {
    name: 'TestPass',
    components: { apexchart, InlineSvg, mediaFiles, timerComponent },
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl',
            userInfo: 'user/userInfo'
        }),
       prettyTime () {
            let hours = this.time / 3600  % 24,
                minutes = this.time / 60 % 60,
                seconds = this.time % 60;

            return `${Math.floor(hours)}:${Math.floor(minutes)}:${Math.floor(seconds)}`
        }
    },
    data() {
        return {
            loadingGetResult: false,
            timer: null,
            time: 0,
            loadingSaveResult: false,
            snackbar: {
                flag: false,
                text: '',
                color: ''
            },
            success: false,
            text: '',
            showInfo: false,
            checkQuest: false,
            loadCheck: false,
            selected: [],
            loading: false,
            currentStep: 1,
            percentages: {
                int: 0,
                txt: '',
                color: null
            },
            clickShow: false,
            answers: [],
            isActive: 0,
            currentTestInfo: {
                questions: [{ questionType: 0, title: '', terms: [], selectedQ0: null, selectedQ1: [], selectedQ2: [], files: [] }],
                title: '',
                studyDisciplineName: '',
                studyTopicName: ''
            },
            assignId: null,
            passTypeId: null
        }
    },
    methods:{
        ...mapActions({
            randomGenerate: 'tests/randomGenerate'
        }),
        pushCheck(it) {
            this.currentTestInfo.questions[this.isActive].selectedQ0 = it;
            this.currentTestInfo.questions[this.isActive].isDiasabled = false;
        },
        pushCheckLot(it) {
            if(this.currentTestInfo.questions[this.isActive].selectedQ1.indexOf(it.id) !== -1) {
                this.currentTestInfo.questions[this.isActive].selectedQ1.splice(this.currentTestInfo.questions[this.isActive].selectedQ1.indexOf(it.id), 1);
            } else {
                this.currentTestInfo.questions[this.isActive].selectedQ1.push(it.id);
            }

            if(this.currentTestInfo.questions[this.isActive].selectedQ1.length > 0) {
                this.currentTestInfo.questions[this.isActive].isDiasabled = false;
                // this.currentTestInfo.questions[this.isActive].isDiasabledNext = false;
            } else {
                this.currentTestInfo.questions[this.isActive].isDiasabled = true;
                // this.currentTestInfo.questions[this.isActive].isDiasabledNext = true;
            }
        },
        pushNext() {
            if(this.currentTestInfo.questions[this.isActive].questionType !== 2) {
                this.resetColor(this.currentTestInfo.questions[this.isActive].answers, this.currentTestInfo.questions[this.isActive].questionType === 0 ? 'check' : 'checkLot');
            }
            this.checkQuest = false;
            this.isActive += 1;
            this.currentTestInfo.questions[this.isActive].isDiasabled = true;
            this.currentTestInfo.questions[this.isActive].isDiasabledNext = true;
            this.currentStep += 1;
        },
        getMark(item) {
            this.loadingGetResult = true;

            for (let i = 0; i < item.questions.length; i++) {
                item.questions[i].selectedAnswers = [];
                item.questions[i].selectedTermAnswers = [];

                if(item.questions[i].questionType === 0) {
                    item.questions[i].selectedAnswers = [item.questions[i].selectedQ0];
                }
                if(item.questions[i].questionType === 1) {
                    for (let j = 0; j < item.questions[i].selectedQ1.length; j++) {
                        for (let k = 0; k < item.questions[i].answers.length; k++) {
                            if (item.questions[i].selectedQ1[j] === item.questions[i].answers[k].id) {
                                item.questions[i].selectedAnswers.push(item.questions[i].answers[k])
                            }
                        }
                    }
                }
                if(item.questions[i].questionType === 2) {
                    item.questions[i].selectedTermAnswers = item.questions[i].terms.map((m) => ({ id: m.selected.id, testQuestionTermId: m.id }))
                }
            }

            this.$http.post(`${this.apiUrl}TestTask/GetShortResult`, {
                testId: item.id,
                title: item.title,
                bodySystemId: item.bodySystemId,
                bodySystemName: item.bodySystemName,
                userId: this.userInfo.id,
                assignId: this.assignId,
                passTypeId: this.passTypeId,
                durationTime: this.time,
                questions: item.questions.map((m) => ({
                    id: m.id,
                    testId: m.testId,
                    title: m.title,
                    questionType: m.questionType,
                    files: m.files,
                    answers: m.answers,
                    selectedAnswers: m.selectedAnswers,
                    terms: m.terms,
                    termAnswers: m.termAnswers,
                    selectedTermAnswers: m.selectedTermAnswers
                }))
            })
            .then((res) => {
                this.percentages.int = res.data.score;
                this.loadingGetResult = false;

                switch (true) {
                    case this.percentages.int >= 0 && this.percentages.int <= 39:
                        this.randomGenerate('0_39').then((text) => {
                            this.percentages.txt = text;
                            this.percentages.color = '#EE4040'
                            this.clickShow = true;
                        })
                        break;
                    case this.percentages.int >= 40 && this.percentages.int <= 69:
                        this.randomGenerate('40_69').then((text) => {
                            this.percentages.txt = text;
                            this.percentages.color = '#EEC840'
                            this.clickShow = true;
                        })
                        break;
                    case this.percentages.int >= 70 && this.percentages.int <= 90:
                        this.randomGenerate('70_90').then((text) => {
                            this.percentages.txt = text;
                            this.percentages.color = '#21B8DA'
                            this.clickShow = true;
                        })
                        break;
                    case this.percentages.int >= 91:
                        this.randomGenerate('91_100').then((text) => {
                            this.percentages.txt = text;
                            this.percentages.color = '#33A56E'
                            this.clickShow = true;
                        })
                        break;
                    default:
                        break;
                }
            })
        },
        startTimer() {
            if(!this.timer) {
                this.timer = setInterval( () => {
                    this.time++
                }, 1000 )
            } else {
                clearInterval(this.timer);
            }
        },
        stopTimer() {
            clearInterval(this.timer);
        },
        get(id, questionsCount) {
            this.loading = true;
            this.$http.get(`${this.apiUrl}TestTask/GetRandom?id=${id}&questionsCount=${questionsCount}`)
                .then((res) => {
                    if(res.data.questions.length > 0) {
                        for (let i = 0; i < res.data.questions.length; i++) {
                            this.$set(res.data.questions[i], 'selectedQ0', { id: null });
                            this.$set(res.data.questions[i], 'selectedQ1', []);
                            this.$set(res.data.questions[i], 'selectedQ2', []);
                            this.$set(res.data.questions[i], 'correct', null);
                            this.$set(res.data.questions[i], 'isDiasabled', true);
                            this.$set(res.data.questions[i], 'isDiasabledNext', true);

                            if(res.data.questions[i].questionType === 2) {
                                for (let j = 0; j < res.data.questions[i].terms.length; j++) {
                                    this.$set(res.data.questions[i].terms[j], 'list', res.data.questions[i].termAnswers);
                                    this.$set(res.data.questions[i].terms[j], 'listFreeze', res.data.questions[i].termAnswers);
                                    this.$set(res.data.questions[i].terms[j], 'selected', null);
                                }
                            }
                        }
                    }

                    this.currentTestInfo = res.data;

                    // console.log(res);

                    // let s = res.timer.split('T')[1],
                    //     hour = +s.split(':')[0],
                    //     min = +s.split(':')[1],
                    //     sec = +s.split(':')[2];

                    // if(hour > 0 || min > 0 || sec > 0) this.time = ((hour * 60) * 60 ) + (min * 60) + sec;
                    this.loading = false;
                })
                .catch((error) => {
                    if(error) {
                        this.loading = false;
                    }
                })
        },
        getIcon(task) {
            if (task.bodySystemIconUrl) {
                return require(`../../../assets/SomaticStatus/${task.bodySystemIconUrl}`);
            } 
            else {
                return '';
            }
        },
        selectTerms(item, it) {
            this.selected = [];

            for (let i = 0; i < item.terms.length; i++) {
                // возвращаем полный список в поле
                item.terms[i].list = item.terms[i].listFreeze;

                // Собираем список выбранных результатов из других полей
                if(item.terms[i].id !== it.id) {
                    this.selected.push(item.terms[i].selected)
                }

                this.$nextTick(() => {
                    // если это поле на которое нажали, то
                    if(it.id === item.terms[i].id) {
                        // если в списке есть выбранный результат
                        if(this.selected.length > 0) {
                            // фильтруем
                            const s = new Set(this.selected.map(e => JSON.stringify(e)));
                            item.terms[i].list = item.terms[i].list.filter(e => !s.has(JSON.stringify(e)));
                        }
                    }
                })
            }
        },
        changeSelected(e, item) {
            if(item.questionType === 2) {
                let success = true;

                for (let i = 0; i < item.terms.length; i++) {
                    if(!item.terms[i].selected) {
                        success = false;
                        break;
                    }
                }

                if(success) {
                    item.isDiasabled = false;
                }

                return;
            }

            if(e) {
                item.isDiasabled = false;
            } else {
                item.isDiasabled = true;
            }
        },
        checkQusest(item) {
            this.loadCheck = true;

            this.$http.get(`${this.apiUrl}TestTask/GetQuestionAnswers?id=${item.id}`)
            .then((res) => {
                this.loadCheck = false;

                if(item.questionType === 0) {
                    // Найти индекс выбранного ответа
                    let index = item.answers.findIndex((f) => f.id === item.selectedQ0.id);

                    // если ответ правильный
                    if(item.answers[index].id === res.data[0].id) {
                        this.randomGenerate('correctlyAnswered').then((res) => {
                            this.text = res;
                            this.success = true;
                        })
                        // флаг что на вопрос ответили корректно
                        item.correct = true;
                        this.percentages.int += 10;

                        for (let i = 0; i < item.answers.length; i++) {
                            if(item.selectedQ0.id === item.answers[i].id) {
                                if(this.$refs[`check${item.answers[i].id}`]) {
                                    this.$refs[`check${item.answers[i].id}`][0].classList.add('correct');
                                    this.$refs[`check${item.answers[i].id}`][1].classList.add('correct');
                                }
                            } else {
                                if(this.$refs[`check${item.answers[i].id}`]) {
                                    this.$refs[`check${item.answers[i].id}`][0].classList.add('wrong');
                                    this.$refs[`check${item.answers[i].id}`][1].classList.add('wrong');
                                }
                            }
                        }
                    } else {
                        this.randomGenerate('wrongAnswer').then((res) => {
                            this.text = res;
                            this.success = false;
                        })
                        // флаг что на вопрос ответили не корректно
                        item.correct = false;

                        for (let i = 0; i < item.answers.length; i++) {
                            if(item.answers[i].id === res.data[0].id) {
                                if(this.$refs[`check${item.answers[i].id}`]) {
                                    this.$refs[`check${item.answers[i].id}`][0].classList.add('correct');
                                    this.$refs[`check${item.answers[i].id}`][1].classList.add('correct');
                                }
                            } else {
                                if(this.$refs[`check${item.answers[i].id}`]) {
                                    this.$refs[`check${item.answers[i].id}`][0].classList.add('wrong');
                                    this.$refs[`check${item.answers[i].id}`][1].classList.add('wrong');
                                }
                            }
                        }
                    }
                }

                if(item.questionType === 1) {
                    // если ответ правильный
                    if(this.check2array(res.data.map((m) => m.id), item.selectedQ1).length === 0) {
                        this.randomGenerate('correctlyAnswered').then((res) => {
                            this.text = res;
                            this.success = true;
                        })
                        // флаг что на вопрос ответили корректно
                        item.correct = true;
                        this.percentages.int += 10;

                        for (let i = 0; i < item.answers.length; i++) {
                            for (let j = 0; j < res.data.length; j++) {
                                if(item.answers[i].id === res.data[j].id) {
                                    if(this.$refs[`checkLot${item.answers[i].id}`]) {
                                        this.$refs[`checkLot${item.answers[i].id}`][0].classList.add('correct');
                                        this.$refs[`checkLot${item.answers[i].id}`][1].classList.add('correct');
                                    }
                                } else {
                                    if(this.$refs[`checkLot${item.answers[i].id}`]) {
                                        this.$refs[`checkLot${item.answers[i].id}`][0].classList.add('wrong');
                                        this.$refs[`checkLot${item.answers[i].id}`][1].classList.add('wrong');
                                    }
                                }
                            }
                        }
                    } else {
                        this.randomGenerate('wrongAnswer').then((res) => {
                            this.text = res;
                            this.success = false;
                        })
                        // флаг что на вопрос ответили не корректно
                        item.correct = false;

                        for (let i = 0; i < item.answers.length; i++) {
                            for (let j = 0; j < res.data.length; j++) {
                                if(item.answers[i].id === res.data[j].id) {
                                    if(this.$refs[`checkLot${item.answers[i].id}`]) {
                                        this.$refs[`checkLot${item.answers[i].id}`][0].classList.add('correct');
                                        this.$refs[`checkLot${item.answers[i].id}`][1].classList.add('correct');
                                    }
                                } else {
                                    if(this.$refs[`checkLot${item.answers[i].id}`]) {
                                        this.$refs[`checkLot${item.answers[i].id}`][0].classList.add('wrong');
                                        this.$refs[`checkLot${item.answers[i].id}`][1].classList.add('wrong');
                                    }
                                }
                            }
                        }
                    }
                }

                this.checkQuest = true;
                item.isDiasabled = true;
                item.isDiasabledNext = false;
            })
        },
        resetColor(arr, name) {
            for (let i = 0; i < arr.length; i++) {
                if(this.$refs[`${name}${arr[i].id}`]) {
                    this.$refs[`${name}${arr[i].id}`][0].classList.remove('correct', 'wrong')
                    this.$refs[`${name}${arr[i].id}`][1].classList.remove('correct', 'wrong')
                }
            }
        },
        checkQuestType2(item) {
            this.$http.get(`${this.apiUrl}TestTask/GetQuestionTermAnswers?id=${item.id}`)
            .then((res) => {
                this.loadCheck = false;

                let success = [];
                for (let i = 0; i < res.data.length; i++) {
                    for (let j = 0; j < item.terms.length; j++) {
                        if(res.data[i].testQuestionTermId === item.terms[j].id) {
                            if(item.terms[j].selected.id == res.data[i].id) {
                                success.push(true);
                                item.terms[j].correct = true;
                            } else {
                                success.push(false);
                                item.terms[j].correct = false;
                                break;
                            }
                        }
                    }
                }

                if(success.indexOf(false) !== -1) {
                    item.correct = false;
                    this.randomGenerate('wrongAnswer').then((res) => {
                        this.text = res;
                        this.success = false;
                    })
                } else {
                    item.correct = true;
                    this.percentages.int += 10;
                    this.randomGenerate('correctlyAnswered').then((res) => {
                        this.text = res;
                        this.success = true;
                    })
                }

                this.checkQuest = true;
                item.isDiasabled = true;
                item.isDiasabledNext = false;
            })
        },
        check2array(a1, a2) {
            return a1.filter(i=>!a2.includes(i)).concat(a2.filter(i=>!a1.includes(i)))
        },
        saveResult(item) {
            this.stopTimer();
            this.loadingSaveResult = true;

            for (let i = 0; i < item.questions.length; i++) {
                item.questions[i].selectedAnswers = [];
                item.questions[i].selectedTermAnswers = [];

                if(item.questions[i].questionType === 0) {
                    item.questions[i].selectedAnswers = [item.questions[i].selectedQ0];
                }
                if(item.questions[i].questionType === 1) {
                    for (let j = 0; j < item.questions[i].selectedQ1.length; j++) {
                        for (let k = 0; k < item.questions[i].answers.length; k++) {
                            if (item.questions[i].selectedQ1[j] === item.questions[i].answers[k].id) {
                                item.questions[i].selectedAnswers.push(item.questions[i].answers[k])
                            }
                        }
                    }
                }
                if(item.questions[i].questionType === 2) {
                    item.questions[i].selectedTermAnswers = item.questions[i].terms.map((m) => ({ id: m.selected.id, testQuestionTermId: m.id }))
                }
            }

            this.$http.post(`${this.apiUrl}TestTask/AddResult`, {
                testId: item.id,
                title: item.title,
                bodySystemId: item.bodySystemId,
                bodySystemName: item.bodySystemName,
                userId: this.userInfo.id,
                assignId: this.assignId,
                passTypeId: this.passTypeId,
                durationTime: this.time,
                questions: item.questions.map((m) => ({
                    id: m.id,
                    testId: m.testId,
                    title: m.title,
                    questionType: m.questionType,
                    files: m.files,
                    answers: m.answers,
                    selectedAnswers: m.selectedAnswers,
                    terms: m.terms,
                    termAnswers: m.termAnswers,
                    selectedTermAnswers: m.selectedTermAnswers
                }))
            }).then(() => {
                this.snackbar.flag = true;
                this.snackbar.text = 'Результат теста успешно сохранен!';
                this.snackbar.color = 'success';

                setTimeout(() => {
                    this.$router.push('/lkstudents/tests');
                }, 1500)
            }).catch((error) => {
                if(error) {
                    this.snackbar.flag = true;
                    this.snackbar.text = 'Ошибка, обратитесь к Администратору!';
                    this.snackbar.color = 'error';
                    this.loadingSaveResult = false;
                    // this.clickShow = false;
                }
            })
        }
    },
    mounted() {
        this.startTimer()
    },
    destroyed() {
        clearInterval(this.timer);
    },
    created() {
        this.get(this.$route.params.id, this.$route.query.questionsCount);
        this.assignId = this.$route.query.assignId;
        this.passTypeId = this.$route.query.passTypeId;
    }
}
</script>
